import { inject } from '@angular/core';
import { CanMatchFn, NavigationExtras, Router, UrlTree } from '@angular/router';
import { environment } from '@env/environment';

const PUBLIC_LANDING_HOST = 'navizard.bakelor.com';

function normalizeHost(value: string | null | undefined): string {
    return (value || '').toString().trim().toLowerCase();
}

function resolveCurrentHostname(): string {
    if (typeof window === 'undefined' || !window.location?.hostname) {
        return '';
    }

    return normalizeHost(window.location.hostname);
}

export function isPublicLandingAllowed(): boolean {
    if (!environment.production) {
        return true;
    }

    return resolveCurrentHostname() === PUBLIC_LANDING_HOST;
}

export function getPublicEntryPath(): '/landing' | '/auth' {
    return isPublicLandingAllowed() ? '/landing' : '/auth';
}

export function createPublicEntryUrlTree(router: Router, returnUrl?: string): UrlTree {
    return router.createUrlTree(
        [getPublicEntryPath()],
        returnUrl
            ? { queryParams: { returnUrl } }
            : undefined
    );
}

export function navigateToPublicEntry(
    router: Router,
    options: {
        returnUrl?: string;
        replaceUrl?: boolean;
    } = {}
): Promise<boolean> {
    const extras: NavigationExtras = {};
    if (options.returnUrl) {
        extras.queryParams = { returnUrl: options.returnUrl };
    }
    if (options.replaceUrl !== undefined) {
        extras.replaceUrl = options.replaceUrl;
    }

    return router.navigate([getPublicEntryPath()], extras);
}

export const publicLandingRootMatch: CanMatchFn = () => isPublicLandingAllowed();

export const publicLandingRouteMatch: CanMatchFn = () => {
    if (isPublicLandingAllowed()) {
        return true;
    }

    return inject(Router).createUrlTree(['/auth']);
};
